// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.jp-menu-category {\n    padding: 0 20px;\n    margin-top: 20px;\n    font-size: 12px;\n    line-height: 38px;\n    color: #76838f;\n    text-transform: uppercase;\n    -webkit-transition: all .25s,font .1s .15s,color .1s .15s;\n    transition: all .25s,font .1s .15s,color .1s .15s;\n}\n", ""]);
// Exports
module.exports = exports;
